import { Box, CircularProgress, Typography, styled } from "@mui/material";
import type { PropsWithChildren } from "react";

const CenteredContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
});

const Title = styled(Typography)({});

interface Props {
  title?: string;
}

export const FullScreenLoader: React.FC<PropsWithChildren<Props>> = ({
  title,
  children,
}) => {
  return (
    <CenteredContainer>
      {title && (
        <Title variant="h5" fontWeight="medium">
          {title}
        </Title>
      )}
      {children}
      <CircularProgress color="primary" />
    </CenteredContainer>
  );
};
